<template>
  <div class="left-box">
    <div class="left-title d-aligncnter" style="font-size: 20px">
      本学期考勤汇总
    </div>
    <div class="">
      <div class="j-flex" style="padding: 16px 16%">
        <div
          v-for="(item, index) in totalData"
          :key="'total_' + index"
          class="d-column d-aligncnter"
        >
          <div style="font-size: 22px">{{ item.name }}</div>
          <div class="num">
            {{ item.num }}
          </div>
        </div>
      </div>
      <div class="left-title" style="font-size: 20px">近一周到课率</div>
      <div class="echarts">
        <div
          id="rate"
          :style="{
            width: '800px',
            height: '320px',
            margin: '0 auto',
          }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['weekSigninData', 'termSignData'],
  data() {
    return {
      attendData: [],
      animatedTop: false,
      timer: null,
      flag: true,
      modeData: 0,
      totalData: [
        { name: '签到', num: 122 },
        { name: '迟到', num: 12 },
        { name: '请假', num: 2 },
        { name: '旷课', num: 22 },
      ],
      option1: {},
      rateData: [90, 80, 99, 88, 99, 78, 90],
      rateDataDay: ['2/15', '2/16', '2/17', '2/18', '2/19', '2/20', '2/21'],
    }
  },
  watch: {
    weekSigninData: {
      handler: function () {
        this.drawLineData(this.weekSigninData.rate)
      },
      deep: true,
    },
    termSignData: {
      handler: function () {
        this.totalData[0].num = this.termSignData.qd
        this.totalData[1].num = this.termSignData.cd
        this.totalData[2].num = this.termSignData.qj
        this.totalData[3].num = this.termSignData.kk
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    setTimeout(() => {
      var myChart1 = this.$echarts.init(document.getElementById('rate'))
      myChart1.setOption(this.option1)
    }, 6000)
    this.drawLineData(this.weekSigninData.rate)
    window.onresize = () => {
      return (() => {
        this.drawLineData(this.weekSigninData.rate)
      })()
    }
  },
  computed: {},
  methods: {
    drawLineData(data) {
      var myChart1 = this.$echarts.init(document.getElementById('rate'))
      this.option1 = {
        tooltip: {},
        xAxis: {
          type: 'category',
          boundaryGap: false,
          //   axisLabel: { interval: 0, rotate: 30 },
          data: this.weekSigninData.date,
          axisTick: {
            alignWithLabel: true,
          },
        },
        axisLabel: {
          color: '#339571',
        },
        yAxis: {
          minInterval: 20,
          axisLine: {
            show: true, //是否显示轴线
            lineStyle: {
              color: '#339571', //刻度线的颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: '#339571',
            },
          },
        },
        series: [
          {
            name: '时间',
            type: 'line',
            // areaStyle: {},
            data: data,
            label: {
              show: true,
              position: 'top',
              formatter: '{c}%',
            },
            itemStyle: {
              color: '#FFB612',
              //   color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              //     { offset: 0, color: '#FFB612' },
              //     { offset: 1, color: '#4DA282' },
              //   ]),
            },
          },
        ],
      }
      myChart1.setOption(this.option1)
    },
  },
}
</script>
<style scoped lang="scss">
.num {
  font-size: 30px;
  margin-top: 8px;
  color: #339571;
  font-weight: 600;
}
.echarts {
  margin-left: calc(24px - 6%);
  height: 477px;
  margin-top: -30px;
}
</style>
